__turbopack_context__.v({
  "accordionButton": "cZ0xfq_accordionButton",
  "container": "cZ0xfq_container",
  "form": "cZ0xfq_form",
  "formWrapper": "cZ0xfq_formWrapper",
  "skeletonAccordion": "cZ0xfq_skeletonAccordion",
  "submitButton": "cZ0xfq_submitButton",
  "voucherInputWrapper": "cZ0xfq_voucherInputWrapper",
});
